<a class="logo">
  <img [src]="logoUrl">
  <span id="icon-close" class="asideNavClose" (click)="navClose()">
    <svg class="icon">
      <use xlink:href="#cross"></use>
    </svg>
  </span>
</a>

<ng-container *ngIf="loan">

  <div class="application-progress">
    <p [class.mb-8px]="!loan.formattedAddress">{{loan.TermsOfLoan.LoanPurposeType}}</p>
    <span *ngIf="loan.formattedAddress">{{loan.formattedAddress}}</span>
    <ng-container *ngIf="!loanSubmitted && (inviteType !== 'DOCUMENT_ONLY')">
      <div class="progress-bar">
        <span [ngStyle]="{'width': (loanStepperService.percentCompletion || 0) + '%'}"></span>
      </div>
      <span><span id="progress-percentage" class="progress-percentage">{{loanStepperService.percentCompletion || 0}}
        %</span>Completed</span>
    </ng-container>
  </div>

  <ng-container *ngIf="!loanSubmitted && (inviteType !== 'DOCUMENT_ONLY') else documentNav">
    <nav class="navigation" *ngIf="loan && posConfig">
      <ul>
        <ng-container *ngFor="let step of loanStepperService.steps">
          <ng-container
            *ngIf="posConfig[(loan.TermsOfLoan.LoanPurposeType || 'purchase').toLowerCase()][step.key] || step.route === 'review'">
            <li routerLinkActive="active"
                [ngClass]="{'completed' : step.complete || (step.route !== 'review' && inviteType === 'REVIEW_ONLY')}"
                (click)="navClose()">
              <ng-container *ngIf="loan.fileVersion === 'URLA_2021' && step.key === 'declarations' else normalLink">
                <a [ngClass]="{'disable' : !step.complete && inviteType === 'REVIEW_ONLY'}"
                   [routerLink]="['application', 'declarations-urla']">{{step.label}}</a>
              </ng-container>
              <ng-template #normalLink>
                <a [ngClass]="{'disable' : !step.complete && inviteType === 'REVIEW_ONLY'}"
                   [routerLink]="['application', step.route]">{{step.label}}</a>
              </ng-template>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </nav>
  </ng-container>

  <ng-template #documentNav>
    <nav class="navigation after-submission">
      <ul>
        <li routerLinkActive="active" (click)="navClose()">
          <a href="javascript:void(0)" class="lg" [routerLink]="['tasks', 'application-details']"
             routerLinkActive="active">
            <svg class="nav-icon">
              <use xlink:href="#loan-details"></use>
            </svg>
            Loan Details
          </a>
        </li>
        <li routerLinkActive="active" (click)="navClose()">
          <a href="javascript:void(0)" [routerLink]="['tasks', 'tasks-list']" routerLinkActive="active" class="lg">
            <svg class="nav-icon">
              <use xlink:href="#icon-tasks"></use>
            </svg>
            Tasks List
            <ng-container *ngIf="pendingTasksCount$ | async as count">
              <span class="counter" *ngIf="count?.pendingTasks">{{count.pendingTasks}}</span>
              <span class="counter others" *ngIf="count?.otherPendingTasks">{{count.otherPendingTasks}}</span>
            </ng-container>
          </a>
        </li>
        <li routerLinkActive="active" (click)="navClose()">
          <a href="javascript:void(0)" [routerLink]="['tasks', 'documents']" routerLinkActive="active" class="lg">
            <svg class="nav-icon">
              <use xlink:href="#pdf-documents"></use>
            </svg>
            Documents
          </a>
        </li>
        <li *ngIf="!(loan.CurrentStage.StageId === this.stagesIds['APPLICATION_INTAKE'] || loan.CurrentStage.StageId === this.stagesIds['QUALIFICATION']) && loan.LoanDetail.IsPreApprovalAllowedByBorrower && loan.LoanProduct.LoanProductDetail.ProductId">
          <button (click)="openPreApprovalDialog(loan);$event.stopPropagation();"
                  [preload]="PreApprovalMod"
                  class="btn min-width-110 btn-outline-primary pre-approve-btn">
            <svg class="icon fill-current lg mr-2">
              <use xlink:href="#download-file-thick"></use>
            </svg>
            {{loan.CurrentStage.StageId === this.stagesIds['PREAPPROVED'] ? 'Pre-Approval' : 'Preview'}}
          </button>
        </li>
      </ul>
    </nav>
  </ng-template>


  <nav class="bottom-navigation navigation" [class.open]="isBottomNavOpen">
    <header class="header" (click)="isBottomNavOpen = !isBottomNavOpen">
      <svg class="icon fill-current sm avatar">
        <use xlink:href="#user"></use>
      </svg>
      <div>
        <span>
          {{currentUser?.firstName ? (currentUser.firstName + ' ' + (currentUser.lastName || '') | titlecase) : (currentUser?.email || 'Hi Applicant') }}
        </span>
        <small>Account Info</small>
      </div>
      <svg class="icon fill-current sm arrow">
        <use xlink:href="#icon-select-input-arrow"></use>
      </svg>
    </header>
    <ul>
      <li (click)="navClose()">
        <a href="javascript:" routerLink="my-profile">
          <svg class="nav-icon">
            <use xlink:href="#user"></use>
          </svg>
          My Profile
        </a>
      </li>
      <ng-container *ngFor="let loanItem of loans">
        <li [ngClass]="{'active': loanItem.LoanId === loan?.id}">
          <a class="fs-unmask" href="javascript:" (click)="selectLoan(loanItem)">
            <svg class="nav-icon">
              <use xlink:href="#icon-home-loan"></use>
            </svg>
            Application #{{loanItem.LoanId}}</a>
        </li>
      </ng-container>
    </ul>
    <footer class="footer fs-unmask">
      <svg class="icon lg fill-current ">
        <use xlink:href="#icon-sign-out"></use>
      </svg>
      <span (click)="logout()">Logout</span>
    </footer>
  </nav>

</ng-container>
